module.exports = __webpack_public_path__ + "img/18.706fea36.png";